import { useEffect, useState } from "react";
import Table from "../../components/Table";
import { apiGetWarehouses, apiWarehouseShortage, apiWarehouseStock } from "../../api/warehouseApi";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import useDateState from "helpers/useDateState";
import { useSearchParams } from "react-router-dom";
import { setQueryParam } from "helpers/queryParam";
import useCurrency from "helpers/useCurrency";
import { useAppDispatch, useAppSelector } from "store/store";
import BasicButton from "components/BasicInputs/BasicButton";
import ExcelIcon from "assets/icons/ExcelIcon";
import axios from "../../axios/axios";
import fileDownload from "js-file-download";
import { errorDispatcher, getOptionsQuery } from "helpers";
import { DateToString } from "../../components/Reports/DateFilter";
import { appSetLoading } from "store/actions/appAction";

export default function InventorySupply(props) {
  const dispatch = useAppDispatch();
  const store = useAppSelector((state) => state);
  const token = store.businessReducer.business?.token;
  const warehouses = store.warehouseReducer?.warehouses;
  const pagination = store.paginationReducer;
  const { fromDate, toDate, setDates } = useDateState();
  const [searchParams] = useSearchParams();
  const warehouseId = searchParams.get("warehouseId");
  const { defCur } = useCurrency();
  const [state, setState] = useState({
    warehouseId,
    totalWarehouseValue: 0,
  });
  const [activeTab, setActiveTab] = useState("inventorySupply")
  const warehouse = warehouses?.find((x) => x.id === parseInt(state.warehouseId)) || {};

  useEffect(() => {
    let data = {};
    if (fromDate && toDate) {
      data = {
        type: "date",
        searchText: fromDate,
        searchTextAlt: toDate,
      };
    }

    props.shortage
      ? dispatch(
        apiWarehouseShortage({
          pagination,
          token,
          search: data,
          key: activeTab || "warehouse",
          id: state.warehouseId,
          cb: (res) => {
            setState((x) => ({ ...x, totalWarehouseValue: res?.totalWarehouseValue }));
          },
        })
      )
      : dispatch(
        apiWarehouseStock({
          pagination,
          token,
          search: data,
          key: activeTab || "warehouse",
          id: state.warehouseId,
          cb: (res) => {
            setState((x) => ({ ...x, totalWarehouseValue: res?.totalWarehouseValue }));
          },
        })
      );
  }, [state.warehouseId, state?.activeTab?.key, fromDate, toDate, activeTab]);

  async function downloadAll() {
    if (!props.shortage) {
      dispatch(appSetLoading(true));


      if (activeTab === "inventorySupply") {
        if (!state.warehouseId) return
        const url = `warehouses/${state.warehouseId}/supply`;
        try {
          const data = {
            excel: true,
            ...getOptionsQuery(pagination, pagination.search, pagination.sort),
            ...(fromDate &&
              toDate && { column: "date", primarySearchText: fromDate, secondarySearchText: toDate }),
          };
          const tokenHeader = { Authorization: `Bearer ${token}` };
          axios
            .post(url, data, {
              headers: { ...tokenHeader },
              responseType: "blob",
            })
            .then((response) => {
              const now = DateToString(Date.now()).replace("/", "_");
              warehouse && fileDownload(response.data, `${warehouse.title || "warehouseSupply"}_${now}.xlsx`);
            })
            .catch((error) => {
              errorDispatcher(error, dispatch);
            }).finally(() => dispatch(appSetLoading(false)))
        } catch (error) {
          errorDispatcher(error, dispatch);
        }

      } else {
        const url = `/warehouses/supply/warehouses`;
        try {
          const data = {
            excel: true,
            ...getOptionsQuery(pagination, pagination.search, pagination.sort),

          };
          const tokenHeader = { Authorization: `Bearer ${token}` };
          axios
            .post(url, data, {
              headers: { ...tokenHeader },
              responseType: "blob",
            })
            .then((response) => {
              const now = DateToString(Date.now()).replace("/", "_");
              warehouse && fileDownload(response.data, `موجودی_انبار_براساس_کالا.xlsx`);
            })
            .catch((error) => {
              errorDispatcher(error, dispatch);
            }).finally(() => dispatch(appSetLoading(false)))
        } catch (error) {
          errorDispatcher(error, dispatch);
        }
      }
    }
  }

  return (
    <Table
      key={props.shortage}
      type={props.shortage ? "inventoryShortage" : "inventorySupply"}
      disableDateFilter
      sumAmountInfo={[
        { name: "quantityFirstPeriod", },
        { name: "increase" },
        { name: "decrease" },
        { name: "quantity" },
        { name: "price", isCurrency: true },
        { name: "total_price", isCurrency: true },
      ]}
      onTabChange={(val) => {
        setActiveTab(val.activeTab.key)
      }}
      middleComp={

        <div className="flex flex-col gap-10">

          <div className="flex flex-wrap items-center justify-between mb-3">
            {["inventorySupply", 'inventoryShortage'].includes(activeTab) && <div className="flex flex-wrap gap-5">
              <div style={{ width: 245 }}>
                <BasicDateInput
                  range
                  placeholder="کل سال مالی"
                  onChange={(x) => setDates(x)}
                  defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                />
              </div>
              <BasicSelect
                style={{ minWidth: 245 }}
                defaultValue={warehouseId}
                options={warehouses}
                onChange={(val) => {
                  setQueryParam("warehouseId", val);
                  setState((x) => ({ ...x, warehouseId: val }));
                }}
                placeholder={"انبار"}
                withSearch
                withRefresh
                refreshList={() => dispatch(apiGetWarehouses(token))}
              />
            </div>
            }
            {!props.shortage && state.warehouseId && (
              <div>
                <BasicButton
                  color="disabled"
                  className="border-[#7D96B8] "
                  variant="outlined"
                  onClick={downloadAll}
                >
                  <ExcelIcon className="text-xl [&>path]:fill-[#7D96B8]" />
                  <span className="text-[#7D96B8]">اکسل</span>
                </BasicButton>
              </div>
            )}
          </div>
        </div>
      }
    />
  );
}
